import React from 'react';
import { PencilIcon, TrashIcon, MapPinIcon, StarIcon, AcademicCapIcon } from '@heroicons/react/24/outline';
import { StarIcon as StarIconSolid } from '@heroicons/react/24/solid';

const TestimonialCard = ({ testimonial, onEdit, onDelete }) => {
    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden group hover:shadow-md transition-all duration-300">
            {/* Header / Image */}
            <div className="p-6 pb-0 flex items-start justify-between">
                <div className="flex items-center gap-4">
                    <div className="relative">
                        <img
                            src={testimonial.image_url || 'https://via.placeholder.com/150'}
                            alt={testimonial.name}
                            className="w-16 h-16 rounded-2xl object-cover border-2 border-slate-50"
                        />
                        <div className="absolute -bottom-1 -right-1 bg-green-500 w-4 h-4 rounded-full border-2 border-white"></div>
                    </div>
                    <div>
                        <h3 className="font-bold text-slate-800 text-lg leading-tight">{testimonial.name}</h3>
                        <div className="flex items-center gap-1 text-slate-500 text-sm mt-1">
                            <MapPinIcon className="h-3.5 w-3.5" />
                            {testimonial.location || 'Location not specified'}
                        </div>
                    </div>
                </div>
                <div className="flex gap-2">
                    <button
                        onClick={() => onEdit(testimonial)}
                        className="p-2 text-slate-400 hover:text-primary-600 hover:bg-primary-50 rounded-xl transition-all duration-200"
                    >
                        <PencilIcon className="h-5 w-5" />
                    </button>
                    <button
                        onClick={() => onDelete(testimonial.id)}
                        className="p-2 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-xl transition-all duration-200"
                    >
                        <TrashIcon className="h-5 w-5" />
                    </button>
                </div>
            </div>

            {/* Content */}
            <div className="p-6">
                <div className="flex items-center gap-1 mb-3">
                    {[...Array(5)].map((_, i) => (
                        i < testimonial.rating ? (
                            <StarIconSolid key={i} className="h-4 w-4 text-yellow-400" />
                        ) : (
                            <StarIcon key={i} className="h-4 w-4 text-slate-300" />
                        )
                    ))}
                </div>

                <p className="text-slate-600 text-sm italic line-clamp-3 mb-4">
                    "{testimonial.text}"
                </p>

                <div className="flex flex-wrap gap-2">
                    {testimonial.loan_type && (
                        <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-blue-50 text-blue-600 rounded-lg text-xs font-semibold">
                            <AcademicCapIcon className="h-3.5 w-3.5" />
                            {testimonial.loan_type}
                        </div>
                    )}
                    <div className={`inline-flex items-center px-3 py-1 rounded-lg text-xs font-semibold ${testimonial.is_active
                            ? 'bg-green-50 text-green-600'
                            : 'bg-slate-50 text-slate-600'
                        }`}>
                        {testimonial.is_active ? 'Active' : 'Inactive'}
                    </div>
                    <div className="inline-flex items-center px-3 py-1 bg-slate-50 text-slate-600 rounded-lg text-xs font-semibold">
                        Order: {testimonial.display_order}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestimonialCard;
